import React, { useMemo } from "react";
import { SheetProvider } from "./SheetState";
import BaseCharacterSheets from "./BaseCharacterSheets";
import "./BaseCharacterSheets.css";

// Colors sorted alphabetically, PLUS a "None" option
const COLOR_OPTIONS = [
  { label: "None", value: "" },
  { label: "Black", value: "#111" },
  { label: "Blue", value: "#337ab7" },
  { label: "Brown", value: "#964B00" },
  { label: "Gray", value: "#ccc" },
  { label: "Green", value: "#5cb85c" },
  { label: "Orange", value: "#f0ad4e" },
  { label: "Pink", value: "#ff5ca8" },
  { label: "Purple", value: "#7b61ff" },
  { label: "Red", value: "#d9534f" },
  { label: "Teal", value: "#5bc0de" },
  { label: "Yellow", value: "#ffd24d" },
];

export default function CharacterSheetsStack({
  initialType = "character",
  survivors = [],
  campaignKeyBase = "kdm__campaign__unknown",
  onSetColor = () => {},
  showColorPicker = true,
  getTitle = (s, idx) => s?.name?.trim() || `Survivor ${idx + 1}`,
  borderWidth = 8, // you asked for thicker border; default to 8
}) {
  const colors = useMemo(() => {
    // Keep "None" at the top, rest alphabetical
    const [noneOpt, ...rest] = COLOR_OPTIONS;
    rest.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    );
    return [noneOpt, ...rest];
  }, []);

  return (
    <div style={{ padding: "10px" }}>
      {survivors.map((s, index) => {
        const selectedColor = s?.borderColor ?? ""; // default NONE
        const title = getTitle(s, index);
        const storageKey = `${campaignKeyBase}__survivor__${s.id}`;

        const hasColor = Boolean(selectedColor);

        return (
          <div
            key={s.id || `${initialType}-${index}`}
            style={{
              marginBottom: "18px",
              border: hasColor ? `${borderWidth}px solid ${selectedColor}` : "1px solid #ddd",
              borderRadius: "8px",
              padding: "12px",
              background: "#fff",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "10px",
                gap: "10px",
              }}
            >
              <div style={{ fontWeight: "bold" }}>{title}</div>

              {showColorPicker ? (
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <label style={{ fontSize: "12px" }}>Color</label>
                  <select
                    value={selectedColor}
                    onChange={(e) => onSetColor(s.id, e.target.value)}
                  >
                    {colors.map((c) => (
                      <option key={c.label} value={c.value}>
                        {c.label}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}
            </div>

            <SheetProvider survivorId={s.id}><BaseCharacterSheets initialType={initialType} storageKey={storageKey} /></SheetProvider>
          </div>
        );
      })}
    </div>
  );
}
